import { FC } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

type AllTasksSvgPropsType = {
  selected?: boolean;
} & SvgIconProps;

const AllTasksSvg: FC<AllTasksSvgPropsType> = ({
  selected = false,
  ...svgProps
}) => {
  return (
    <SvgIcon
      {...svgProps}
      sx={{
        '& path': {
          fill: ({ palette }) =>
            selected ? palette.primary.main : palette.customGrey.ultraLight,
        },
        ...svgProps.sx,
      }}
    >
      <g clipPath="url(#clip0_823_2495)">
        <path d="M13.8245 5.30826C13.7434 5.19916 13.6378 5.11065 13.5162 5.04986C13.3946 4.98906 13.2605 4.95769 13.1245 4.95825H12.25V4.08325C12.2496 3.77394 12.1266 3.4774 11.9079 3.25868C11.6892 3.03996 11.3926 2.91694 11.0833 2.91659H6.63498C6.54818 2.91677 6.46244 2.89749 6.38407 2.86018C6.3057 2.82286 6.23668 2.76846 6.18211 2.70096L5.61073 1.99728C5.4743 1.82857 5.30179 1.69257 5.10588 1.59929C4.90998 1.50601 4.69566 1.45782 4.47869 1.45825H1.16667C0.857354 1.4586 0.560809 1.58163 0.342092 1.80035C0.123375 2.01906 0.000347391 2.31561 0 2.62492L0 11.2499C0.000393691 11.5923 0.13661 11.9207 0.378766 12.1628C0.620922 12.405 0.949243 12.5412 1.2917 12.5416H11.1102C11.3896 12.5405 11.6611 12.4494 11.8846 12.2818C12.1081 12.1142 12.2716 11.879 12.3508 11.6112L13.9647 6.07825C14.0033 5.9479 14.0107 5.81031 13.9863 5.67656C13.962 5.54281 13.9066 5.41665 13.8245 5.30826ZM1.2917 11.9583C1.10389 11.9581 0.923833 11.8834 0.791032 11.7506C0.65823 11.6178 0.583534 11.4377 0.583333 11.2499V2.62492C0.583488 2.47026 0.644995 2.32198 0.754358 2.21261C0.863721 2.10325 1.012 2.04174 1.16667 2.04159H4.47869C4.60887 2.04132 4.73745 2.07023 4.85499 2.1262C4.97252 2.18217 5.07602 2.26378 5.15786 2.36502L5.72924 3.06869C5.83842 3.20365 5.97645 3.31243 6.13319 3.38705C6.28992 3.46167 6.46138 3.50024 6.63498 3.49992H11.0833C11.238 3.50008 11.3863 3.56158 11.4956 3.67095C11.605 3.78031 11.6665 3.92859 11.6667 4.08325V4.95825H4.83359C4.55429 4.95936 4.28279 5.05047 4.05938 5.21807C3.83596 5.38567 3.67253 5.62084 3.59333 5.88867L1.97167 11.4481C1.92823 11.595 1.83863 11.7239 1.71615 11.8158C1.59366 11.9077 1.44482 11.9576 1.2917 11.9583ZM13.4046 5.91492L11.7908 11.4478C11.7473 11.5948 11.6576 11.7238 11.535 11.8157C11.4124 11.9077 11.2635 11.9576 11.1102 11.9583H2.37093C2.44164 11.8514 2.49583 11.7345 2.53167 11.6115L4.15333 6.052C4.19678 5.9051 4.28642 5.77611 4.40895 5.68417C4.53149 5.59223 4.68039 5.54223 4.83359 5.54159H13.1246C13.1698 5.54157 13.2145 5.55209 13.255 5.57233C13.2956 5.59257 13.3308 5.62197 13.358 5.6582C13.3852 5.69442 13.4036 5.73648 13.4117 5.78104C13.4198 5.8256 13.4174 5.87144 13.4047 5.91492H13.4046Z" />
      </g>
      <defs>
        <clipPath id="clip0_823_2495">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export default AllTasksSvg;
